module.exports = __webpack_public_path__ + "static/media/logo.a269ec38.png";